// A failed request is a hint, not proof of an outage: callers ask the
// connectivity monitor to verify instead of marking the app offline directly.
let checkHandler: (() => void) | undefined;

export const setConnectivityCheckHandler = (handler: () => void) => {
  checkHandler = handler;
  return () => {
    if (checkHandler === handler) checkHandler = undefined;
  };
};

export const requestConnectivityCheck = () => {
  checkHandler?.();
};
